import React, { useState, useEffect, useRef } from "react";
import Alert from "react-bootstrap/Alert";
import NoteIcon from "./img/note2.webp";
import { Button, Form, Spinner } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import NotizArtenTabs from "./NotizArtenTabs";
import { notizarten, notizfarben, notiznamen } from "./globalVariables";
import { useConfig } from "./ConfigContext";

export default function NotizUbersicht({
   lastLogin,
   handleElementBlock,
   currentElement,
   blockedField,
   notizen,
   updateNotes,
   loading,
   user,
}) {
   const config = useConfig();
   const [showUbersicht, setShowUbersicht] = useState(false);
   const [showWarning, setShowWarning] = useState(false);
   const [expandNote, setExpandNote] = useState(false);
   const [sortedBy, setSortedBy] = useState("date");
   const [selectedNotizart, setSelectedNotizart] = useState("Alle");
   const [filteredNotizen, setFilteredNotizen] = useState([]);
   const [newNotizen, setNewNotizen] = useState();
   const [activeType, setActiveType] = useState({
      Allgemein: false,
      Besichtigung: false,
      Expose: false,
      Notar: false,
      Rechnungsstellung: false,
   });
   // console.log(blockedField[config.estate.notiz]);

   useEffect(() => {
      // console.log(notizen);
      if (notizen && selectedNotizart) {
         let newFilteredNotizen = [];
         if (selectedNotizart === "Alle") {
            newFilteredNotizen = notizen;
         } else {
            newFilteredNotizen = Object.keys(notizen).reduce(
               (oldObj, item) =>
                  notizen[item].findIndex((itemnotiz) => itemnotiz.type[selectedNotizart]) != -1
                     ? { ...oldObj, [item]: notizen[item] }
                     : { ...oldObj },
               {},
            );
         }
         setFilteredNotizen(newFilteredNotizen);
      }
   }, [notizen, selectedNotizart]);

   useEffect(() => {
      const typecounter = notizarten.reduce((oldObj, ite) => ({ ...oldObj, [ite.value]: 0 }), {});
      const newNotizCounter = structuredClone(typecounter);
      Object.values(notizen)
         .flat()
         .map((item) => ({ ...item.type, timestamp: item.timestamp }))
         .flat()
         .forEach((item) => {
            Object.keys(item).forEach((itKey) => {
               if (item[itKey].active) {
                  typecounter[itKey]++;
                  if (new Date(item.timestamp) > lastLogin) {
                     newNotizCounter[itKey]++;
                  }
               }
            });
         });

      setNewNotizen(newNotizCounter);
      setActiveType(typecounter);
   }, [notizen]);

   function closeModal() {
      setShowUbersicht(false);
      handleElementBlock(false, config.estate.notiz, notizen);
   }

   return (
      <>
         <div
            className="notiz-buttongroup mt-1"
            style={blockedField[config.estate.notiz] ? { opacity: 1, outline: "solid 6px #f0a" } : {}}
         >
            {notizarten.map((notizart, index) => {
               if (activeType[notizart.value] > 0) {
                  return (
                     <button
                        key={"notizart_" + notizart.value}
                        className="notiz-button"
                        style={{
                           /* borderColor:  notizfarben.Allgemein, color: */ backgroundColor:
                              notizfarben[notizart.value],
                        }}
                        title="Aktive Allgemein-Notizen"
                        onClick={(e) => {
                           e.preventDefault();
                           setSelectedNotizart(notizart.value);
                           setShowUbersicht(true);
                        }}
                     >
                        {" "}
                        <span>{activeType[notizart.value]}</span>
                        {newNotizen?.[notizart.value] > 0 && (
                           <span
                              style={
                                 {
                                    backgroundColor: "#fffa",
                                    color: "#000",
                                    borderRadius: "8px",
                                    padding: "0 10px",
                                    textShadow: "3px 2px 1px #0003",
                                 } /* {color: "#000", textShadow: "4px 4px #fff"} */
                              }
                           >
                              {newNotizen[notizart.value]}
                           </span>
                        )}{" "}
                        {notizart.name}
                     </button>
                  );
               }
            })}

            {!Object.values(activeType).findIndex((type) => !type && !(type > 0)) && (
               <button
                  className="notiz-button"
                  style={{ /* borderColor:  notizfarben.Allgemein, color: */ backgroundColor: "#000" }}
                  title="Alle Notizen"
                  onClick={(e) => {
                     e.preventDefault();
                     setSelectedNotizart("Alle");
                     setShowUbersicht(true);
                  }}
               >
                  Alle Notizen
               </button>
            )}
         </div>

         <Modal show={showUbersicht} size="xl" className="" onHide={() => closeModal()}>
            <Modal.Body>
               <div className="nachrichten-ubersicht">
                  <h3>
                     <img className="me-3" src={NoteIcon} height={36} />
                     Notizen
                     {blockedField[config.estate.notiz] && (
                        <small style={{ color: "#f0a" }}>
                           {" "}
                           ... wird aktuell bearbeitet von{" "}
                           {blockedField[config.estate.notiz] && blockedField[config.estate.notiz].user
                              ? blockedField[config.estate.notiz].user.Name
                              : "Fehler"}
                        </small>
                     )}
                  </h3>
                  <NotizArtenTabs selectedNotizart={selectedNotizart} setSelectedNotizart={setSelectedNotizart} />
                  <div className="mb-3">
                     <Button
                        variant={sortedBy === "date" ? "dark" : "outline-dark"}
                        onClick={() => setSortedBy("date")}
                        className="me-2 mb-1"
                     >
                        Sortieren nach Datum
                     </Button>
                     <Button
                        variant={sortedBy === "kachel" ? "dark" : "outline-dark"}
                        onClick={() => setSortedBy("kachel")}
                        className="me-2 mb-1"
                     >
                        Sortieren nach Kachel
                     </Button>
                  </div>
                  <div
                     onClick={() => {
                        if (!currentElement.element || currentElement.element !== config.estate.notiz) {
                           handleElementBlock(true, config.estate.notiz, notizen);
                        }
                     }}
                     style={
                        blockedField[config.estate.notiz]
                           ? { pointerEvents: "none", opacity: 0.9, filter: "saturate(0)" }
                           : {}
                     }
                  >
                     {sortedBy === "kachel" &&
                        Object.keys(filteredNotizen).map((kachel) => {
                           return (
                              <div key={"notizkachelkey_" + kachel} className="kachel-notizbereich">
                                 <h5>{kachel}</h5>
                                 {notizen[kachel] &&
                                    notizen[kachel]
                                       .sort((sortA, sortB) => {
                                          let sortIndicator = 0;
                                          if (new Date(sortA.timestamp) > new Date(sortB.timestamp)) sortIndicator = 1;
                                          else sortIndicator = -1;

                                          return sortIndicator * -1;
                                       })
                                       .map((notiz, index2) => {
                                          let activeNote =
                                             selectedNotizart === "Alle" ||
                                             Object.keys(notiz.type).includes(selectedNotizart);
                                          if (!activeNote) return null;
                                          else
                                             return (
                                                <div
                                                   key={"notizkey_" + index2}
                                                   className="kachel-notiz"
                                                   style={
                                                      notiz.active === 0 && kachel + index2 != expandNote
                                                         ? { opacity: 0.5 }
                                                         : {}
                                                   }
                                                >
                                                   {Object.keys(notiz.type).map(
                                                      (notizartkey) =>
                                                         (selectedNotizart === "Alle" ||
                                                            selectedNotizart === notizartkey) && (
                                                            <div key={"notizen_" + notizartkey}>
                                                               {showWarning === kachel + index2 + notizartkey && (
                                                                  <Alert variant="danger">
                                                                     <Alert.Heading>
                                                                        {notizartkey}-Notiz wirklich{" "}
                                                                        {notiz.type[notizartkey].active
                                                                           ? "abhaken"
                                                                           : "aktivieren"}
                                                                        ?
                                                                     </Alert.Heading>
                                                                     <Button
                                                                        variant="dark"
                                                                        className="me-2"
                                                                        onClick={() => setShowWarning(false)}
                                                                     >
                                                                        Abbrechen
                                                                     </Button>
                                                                     <Button
                                                                        variant="danger"
                                                                        onClick={() => {
                                                                           let cloneNotes = structuredClone(notizen);
                                                                           cloneNotes[kachel][index2].type[
                                                                              notizartkey
                                                                           ].active =
                                                                              !cloneNotes[kachel][index2].type[
                                                                                 notizartkey
                                                                              ].active;
                                                                           cloneNotes[kachel][index2].type[
                                                                              notizartkey
                                                                           ].user = user.Name;

                                                                           cloneNotes[kachel][index2].active +=
                                                                              cloneNotes[kachel][index2].type[
                                                                                 notizartkey
                                                                              ].active
                                                                                 ? 1
                                                                                 : -1;
                                                                           updateNotes(cloneNotes);

                                                                           setShowWarning(false);
                                                                        }}
                                                                     >
                                                                        Bestätigen
                                                                     </Button>
                                                                  </Alert>
                                                               )}
                                                               <Button
                                                                  disabled={loading}
                                                                  onClick={() => {
                                                                     setShowWarning(kachel + index2 + notizartkey);
                                                                  }}
                                                                  className="mb-1 me-3"
                                                                  variant={
                                                                     notiz.type[notizartkey].active
                                                                        ? "outline-light"
                                                                        : "outline-secondary"
                                                                  }
                                                                  style={
                                                                     notiz.type[notizartkey].active
                                                                        ? {
                                                                             width: "200px",
                                                                             backgroundColor: notizfarben[notizartkey],
                                                                          }
                                                                        : { width: "200px" }
                                                                  }
                                                               >
                                                                  {loading ? (
                                                                     <Spinner
                                                                        as="span"
                                                                        animation="grow"
                                                                        size="sm"
                                                                        role="status"
                                                                        aria-hidden="true"
                                                                     />
                                                                  ) : (
                                                                     notiznamen[notizartkey] +
                                                                     (!notiz.type[notizartkey].active ? " ✓" : "")
                                                                  )}
                                                               </Button>
                                                               <span>
                                                                  <small>
                                                                     {" "}
                                                                     {notiz.type[notizartkey].user
                                                                        ? "bearbeitet von " +
                                                                          notiz.type[notizartkey].user
                                                                        : ""}
                                                                  </small>
                                                               </span>
                                                            </div>
                                                         ),
                                                   )}
                                                   <p className="kachel-notiztext mt-2">{notiz.text}</p>
                                                   <footer>
                                                      {notiz.bearbeitet && <strong>bearbeitet</strong>} von {notiz.user}{" "}
                                                      {new Date(notiz.timestamp).toLocaleString()}
                                                   </footer>
                                                </div>
                                             );
                                       })}
                              </div>
                           );
                        })}

                     {sortedBy === "date" && (
                        <div>
                           {notizen &&
                              Object.keys(filteredNotizen)?.length &&
                              Object.keys(filteredNotizen)
                                 .reduce((oldArr, kachel) => {
                                    return [
                                       ...oldArr,
                                       ...(notizen?.[kachel]?.map((ite, index) => ({
                                          ...ite,
                                          kachel: kachel,
                                          index: index,
                                       })) ?? []),
                                    ];
                                 }, [])
                                 .sort((sortA, sortB) => {
                                    let sortIndicator = 0;
                                    if (new Date(sortA.timestamp) > new Date(sortB.timestamp)) sortIndicator = 1;
                                    else sortIndicator = -1;

                                    return sortIndicator * -1;
                                 })
                                 .map((notiz, index2) => {
                                    let activeNote =
                                       selectedNotizart === "Alle" ||
                                       Object.keys(notiz.type).includes(selectedNotizart);
                                    if (!activeNote) return null;
                                    else
                                       return (
                                          <div
                                             key={"notizkey_" + index2}
                                             className="kachel-notiz"
                                             style={
                                                notiz.active === 0 && notiz.kachel + notiz.index != expandNote
                                                   ? { opacity: 0.5 }
                                                   : {}
                                             }
                                          >
                                             <h5>{notiz.kachel}</h5>
                                             {Object.keys(notiz.type).map(
                                                (notizartkey) =>
                                                   (selectedNotizart === "Alle" ||
                                                      selectedNotizart === notizartkey) && (
                                                      <div key={"notizen_" + notizartkey}>
                                                         {showWarning === notiz.kachel + notiz.index + notizartkey && (
                                                            <Alert variant="danger">
                                                               <Alert.Heading>
                                                                  {notizartkey}-Notiz wirklich{" "}
                                                                  {notiz.type[notizartkey].active
                                                                     ? "abhaken"
                                                                     : "aktivieren"}
                                                                  ?
                                                               </Alert.Heading>
                                                               <Button
                                                                  variant="dark"
                                                                  className="me-2"
                                                                  onClick={() => setShowWarning(false)}
                                                               >
                                                                  Abbrechen
                                                               </Button>
                                                               <Button
                                                                  variant="danger"
                                                                  onClick={() => {

                                                                     let cloneNotes = structuredClone(notizen);
                                                                     cloneNotes[notiz.kachel][notiz.index].type[
                                                                        notizartkey
                                                                     ].active =
                                                                        !cloneNotes[notiz.kachel][notiz.index].type[
                                                                           notizartkey
                                                                        ].active;
                                                                     cloneNotes[notiz.kachel][notiz.index].type[
                                                                        notizartkey
                                                                     ].user = user.Name;

                                                                     cloneNotes[notiz.kachel][notiz.index].active +=
                                                                        cloneNotes[notiz.kachel][notiz.index].type[
                                                                           notizartkey
                                                                        ].active
                                                                           ? 1
                                                                           : -1;

                                                                     updateNotes(cloneNotes);
                                                                     setShowWarning(false);
                                                                  }}
                                                               >
                                                                  Bestätigen
                                                               </Button>
                                                            </Alert>
                                                         )}
                                                         <Button
                                                            disabled={loading}
                                                            onClick={() => {
                                                               setShowWarning(notiz.kachel + notiz.index + notizartkey);
                                                            }}
                                                            className="mb-1 me-3"
                                                            variant={
                                                               notiz.type[notizartkey].active
                                                                  ? "outline-light"
                                                                  : "outline-secondary"
                                                            }
                                                            style={
                                                               notiz.type[notizartkey].active
                                                                  ? {
                                                                       width: "200px",
                                                                       backgroundColor: notizfarben[notizartkey],
                                                                    }
                                                                  : { width: "200px" }
                                                            }
                                                         >
                                                            {loading ? (
                                                               <Spinner
                                                                  as="span"
                                                                  animation="grow"
                                                                  size="sm"
                                                                  role="status"
                                                                  aria-hidden="true"
                                                               />
                                                            ) : (
                                                               notiznamen[notizartkey] +
                                                               (!notiz.type[notizartkey].active ? " ✓" : "")
                                                            )}
                                                         </Button>
                                                         <span>
                                                            <small>
                                                               {" "}
                                                               {notiz.type[notizartkey].user
                                                                  ? "bearbeitet von " + notiz.type[notizartkey].user
                                                                  : ""}
                                                            </small>
                                                         </span>
                                                      </div>
                                                   ),
                                             )}
                                             <p className="kachel-notiztext mt-2">{notiz.text}</p>
                                             <footer>
                                                {notiz.bearbeitet && <strong>bearbeitet</strong>} von {notiz.user}{" "}
                                                {new Date(notiz.timestamp).toLocaleString()}
                                             </footer>
                                          </div>
                                       );
                                 })}
                        </div>
                     )}
                  </div>
               </div>
            </Modal.Body>
            <Modal.Footer>
               <Button variant="secondary" onClick={() => closeModal()}>
                  Schließen
               </Button>
            </Modal.Footer>
         </Modal>
      </>
   );
}
